import React from 'react';
import { Helmet } from 'react-helmet-async';
import Banner from '../components/common/Banner';
import CourseOverview from '../components/tnpsc/CourseOverview';
import CourseDescription from '../components/tnpsc/CourseDescription';
import SyllabusSection from '../components/tnpsc/SyllabusSection';
import BatchDetails from '../components/tnpsc/BatchDetails';
import FAQSection from '../components/contact/FAQSection';
import styled from 'styled-components';
import Button from '../components/common/Button';

const CTASection = styled.section`
  background-color: ${props => props.theme.colors.primaryColor};
  padding: 80px 0;
  text-align: center;
  color: white;
`;

const CTATitle = styled.h2`
  color: white;
  font-size: ${props => props.theme.fontSizes.xxxlarge};
  margin-bottom: 15px;
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    font-size: ${props => props.theme.fontSizes.xxlarge};
  }
`;

const CTADescription = styled.p`
  font-size: ${props => props.theme.fontSizes.medium};
  margin-bottom: 30px;
  color: rgba(255, 255, 255, 0.8);
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    font-size: ${props => props.theme.fontSizes.regular};
  }
`;

const CTAButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    flex-direction: column;
    align-items: center;
    width: 80%;
    margin: 0 auto;
  }
`;

const TNPSCPage = () => {
  return (
    <>
      <Helmet>
        <title>TNPSC Exam Coaching - KALS Academy</title>
        <meta name="description" content="Comprehensive coaching for TNPSC Combined Technical Services Examination. Junior Draughting Officer & Overseers coaching with high success rate." />
      </Helmet>
      
      <Banner title="TNPSC Combined Technical Services Examination" />
      <CourseOverview />
      <CourseDescription />
      <SyllabusSection />
      <BatchDetails />
      <FAQSection 
        title="Frequently Asked Questions About TNPSC Coaching"
        subtitle="Find answers to common questions about our TNPSC exam coaching program"
      />
      
      <CTASection>
        <div className="container">
          <CTATitle>Ready to Start Your TNPSC Preparation?</CTATitle>
          <CTADescription>
            Join our specialized coaching program and increase your chances of success
          </CTADescription>
          <CTAButtons>
            <Button to="/contact" variant="primary" 
              style={{ backgroundColor: 'white', color: '#3498db' }}
            >
              Enroll Now
            </Button>
            <Button variant="outline" outline="primary"
              style={{ borderColor: 'white', color: 'white' }}
            >
              Download Course Brochure
            </Button>
          </CTAButtons>
        </div>
      </CTASection>
    </>
  );
};

export default TNPSCPage;
